import { CLIENTS, INDEX } from "../../applications";

export const environment = {
    production: false,
    APP_VERSION: '1.0.0',
    APP_NAME: CLIENTS[INDEX - 1].appName,
    IDENTIFIER: CLIENTS[INDEX - 1].identifier,
    API_URL: "https://console.sparkalz.com/api/",
    BASE_URL: 'https://console.sparkalz.com/',
    // API_URL: "http://localhost:8000/api/",
    // BASE_URL: 'http://localhost:8000/',
    // API_URL: "https://staging.sparkalz.com/api/",
    // BASE_URL: 'https://staging.sparkalz.com/',
    LOGIN_PAGE: '/signin',
};
